export enum I18nLabel {
    Close_Tab = "Close",
    Move_Tab = "Move: ",
    Move_Tabset = "Move tabset",
    Maximize = "Maximize tabset",
    Restore = "Restore tabset",
    Float_Tab = "Show selected tab in floating window",
    Overflow_Menu_Tooltip = "Hidden tabs",
    Floating_Window_Message = "This panel is shown in a floating window",
    Floating_Window_Show_Window = "Show window",
    Floating_Window_Dock_Window = "Dock window",
    Error_rendering_component = "Error rendering component",
}



// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexlayout-react/src/I18nLabel.ts